import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from '@material-ui/core';
import { createLayer, removeLayerIfExists } from 'utils/map/layers';
import { addZonesFeaturesToLayer } from 'components/zones/utils/zoneDetailsUtils';
import { addApprovedAreasToLayer } from 'components/approvedAreas/utils/main';
import { addLayerToMap } from 'utils/map/map';
import Icons from 'consts/icons';
import { connect, useSelector } from 'react-redux';
import ButtonsUseStyles from 'consts/styles/Buttons';
import { formStyles } from 'consts/styles/Form';
import { mapUseStyles } from './mapUseStyles';

const ObjectsRender = props => {
  const { map, allZones, allLocalZones, approvedAreas } = props;
  const [showObjects, setShowObjects] = React.useState(false);
  const [selectedObjectTypes, setSelectedObjectTypes] = React.useState([]);
  const allZoneLayer = React.useRef(null);
  const localZoneLayer = React.useRef(null);
  const approvedAreasLayer = React.useRef(null);
  const [layersObject, setLayersObject] = React.useState(null);

  const classes = mapUseStyles();
  const classesButtons = ButtonsUseStyles();
  const formClasses = formStyles();

  const types = [
    { id: 1, name: 'ANSP', icon: <Icons.Filters.ButtonPublic /> },
    { id: 2, name: 'LOCAL', icon: <Icons.Filters.ButtonPrivate /> },
    { id: 3, name: 'CORRIDOR', icon: <Icons.Dashboard.Analytics /> },
  ];
  const init = () => {
    allZoneLayer.current = createLayer('allZoneLayer');
    localZoneLayer.current = createLayer('localZoneLayer');
    approvedAreasLayer.current = createLayer('approvedAreasLayer');
    setLayersObject({
      ANSP: allZoneLayer,
      LOCAL: localZoneLayer,
      CORRIDOR: approvedAreasLayer,
    });
  };

  React.useEffect(init, []);

  const useString = () => useSelector(state => state.language);

  const language = useString();

  React.useEffect(() => {
    addZonesFeaturesToLayer(allZoneLayer.current, allZones);
  }, [allZones]);

  React.useEffect(() => {
    addZonesFeaturesToLayer(localZoneLayer.current, allLocalZones);
  }, [allLocalZones]);

  React.useEffect(() => {
    addApprovedAreasToLayer(approvedAreasLayer.current, approvedAreas);
  }, [approvedAreas]);

  const removeAllLayers = () => {
    if (!showObjects) {
      selectedObjectTypes.forEach(type => {
        removeLayerIfExists(map.current, layersObject[type].current);
      });
      setSelectedObjectTypes([]);
    }
  };
  React.useEffect(removeAllLayers, [showObjects]);

  const handleChangeFilters = type => {
    if (!type) return;
    if (!selectedObjectTypes.includes(type)) {
      addLayerToMap(map.current, layersObject[type].current);
      setSelectedObjectTypes([...selectedObjectTypes, type]);
    } else {
      removeLayerIfExists(map.current, layersObject[type].current);
      setSelectedObjectTypes(
        selectedObjectTypes.filter(value => value !== type)
      );
    }
  };

  const isTypeSelected = type => selectedObjectTypes.includes(type);

  return (
    <div className={`${classes.DrawingApprovedAreasMap}__object-wrapper`}>
      <div
        className={`${formClasses.Form}--flex ${formClasses.Form}--flex--direction`}
      >
        <Tooltip arrow placement="right" title={language.drawMap.tooltip_}>
          <Button
            type="button"
            fullWidth
            onClick={() => setShowObjects(!showObjects)}
            className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}--mid ${classesButtons.ButtonsCircle}`}
          >
            {showObjects ? (
              <Icons.Actions.Preview />
            ) : (
              <Icons.Actions.HidePreview />
            )}
          </Button>
        </Tooltip>

        {types.map(type => (
          <Tooltip key={type.id} arrow placement="right" title={type.name}>
            <div>
              <Button
                type="button"
                disabled={!showObjects}
                className={`${classesButtons.Buttons}--color ${
                  classesButtons.ButtonsCircle
                } ${classesButtons.ButtonsCircle}--small ${
                  classesButtons.ButtonsCircle
                }__transparent ${
                  isTypeSelected(type.name)
                    ? `${classesButtons.ButtonsCircle}__transparent--active`
                    : ''
                }`}
                name={type.name}
                classes={{
                  disabled: `${classesButtons.ButtonsCircle}__transparent--disable`,
                }}
                onClick={event => handleChangeFilters(event.currentTarget.name)}
              >
                {type.icon}
              </Button>
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  );
};

ObjectsRender.propTypes = {
  map: PropTypes.object.isRequired,
  allZones: PropTypes.object.isRequired,
  allLocalZones: PropTypes.object.isRequired,
  approvedAreas: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  allZones: state.allZones,
  allLocalZones: state.allLocalZones,
  approvedAreas: state.approvedAreas,
});

export default connect(mapStateToProps)(ObjectsRender);
